// extracted by mini-css-extract-plugin
export default {"zones":"index_zones__YOByh","action":"index_action__cQK33","card":"index_card__D50Lz","content":"index_content__hx9DW"};